import script from "./Warehouse.vue?vue&type=script&setup=true&lang=ts"
export * from "./Warehouse.vue?vue&type=script&setup=true&lang=ts"

import "./Warehouse.vue?vue&type=style&index=0&id=3ddd4cca&lang=scss&scoped=true"

import exportComponent from "E:\\云工厂标准版\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ddd4cca"]])

export default __exports__